import 'es6-promise/auto'
import Vue from 'vue'
import App from './App'
import router from './router'
import store from '@/store'
import VueCookie from 'vue-cookie'
import VueClipboards from 'vue-clipboards';
import { myPlugin } from '@/utils'
import ElementUI from 'element-ui';
// 自定义主题
import '@/assets/scss/app.scss'


let R = store.state.userRole
let qq = 800822910
if (R == 4 || R == 5 || /www.jf24k/.test(window.location.origin)) {
  qq = 4006182188
}

Vue.use(ElementUI);
Vue.use(VueClipboards);
Vue.use(VueCookie)
Vue.use(myPlugin, qq)

Vue.prototype.$loading = ElementUI.Loading;

Vue.config.productionTip = false

new Vue({
  el: '#app',
  store,
  router,
  render: h => h(App)
})


// WEBPACK FOOTER //
// ./src/main.js